module.exports = __webpack_public_path__ + "static/media/circle_star_white.fb57ec03.png";